import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import {
    resetPassword as resetPasswordAction,
    setPassword as setPasswordAction,
} from '../../actions/auth';

import ResetPasswordPage from './ResetPasswordPage';

const _mapStateToProps = (state) => ({
    locale: state.authentication.locale,
});

const _mapDispatchToProps = {
    handleResetPassword: resetPasswordAction,
    handleSetPassword: setPasswordAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(ResetPasswordPage),
);
